import React, { JSX, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import OTPForm from './OTPForm';
import VideoForm from './VideoForm';
import VideoFormCnt from './VideoFormCnt';
import { useUser } from '../context/UserContext';

import OccupationSurvey from './OccupationSurveyForm';
import UserInformationForm from './UserInformationForm';
import DecisionSurvey from './DecisionSurvey';
import VideoCloseForm from './VideoCloseForm';
import UserDetailsForm from './UserDetailsForm';
import Register from './Register';
import Login from './Login';
import ContactUploadForm from "./ContactUploadForm";

const RedirectBasedOnQueryParam: React.FC = () => {
  const location = useLocation();
  const [componentToRender, setComponentToRender] = useState<JSX.Element | null>(null);
  const { setUser } = useUser();

  const currentPath = location.pathname;
  // Extract query parameters
  const urlParams = new URLSearchParams(location.search);
  const type = urlParams.get('type');
  const addMedia = urlParams.get('adMedia');
  
  const { name, mobile, whatsapp, language, email, country, state, district, city, pinCode } = location.state || {};

  useEffect(() => {
    console.log("currentPath: " + currentPath);
    // Update the user context if necessary
    if(type === 'intro' || type === 'cnt') {
        const name = urlParams.get('n');
        const mobile = urlParams.get('m');
        const whatsapp = urlParams.get('wa');
        const language = urlParams.get('ln');
        const email = urlParams.get('em');
        const country = urlParams.get('cn');
        const state = urlParams.get('cns');
        const district = urlParams.get('district');
        const city = urlParams.get('city');
        const pinCode = urlParams.get('pinCode');
        setUser({
            name: name || '',
            mobile: mobile || '',
            whatsapp: whatsapp || '',
            language: language || '',
            email: email || '',
            country: country || '',
            state: state || '',
            district: district || '',
            city: city || '',
            pinCode: pinCode || '',
          });
        // Determine the component to render based on the `type` query parameter
        if (type === 'intro') {
            setComponentToRender(
                <VideoForm
                />
            );
        } else if (type === 'cnt') {
        setComponentToRender(
            <VideoFormCnt
            />
        );
        } 
    } else if (type === 'join') { 
        setComponentToRender(<OTPForm />);
    } else {
        console.log("Else:" + currentPath);
        if(currentPath === '/video') {
            setComponentToRender(
                <VideoForm
                />
            );
        } else if(currentPath === '/videoFormCnt') {
            setComponentToRender(
                <VideoForm
                />
            );
        } else if(currentPath === '/occupationSurvey') {
            setComponentToRender(<OccupationSurvey />);
        } else if(currentPath === '/userInFormatin') {
            setComponentToRender(<UserInformationForm />);
        } else if(currentPath === '/decisionSurvey') {
            setComponentToRender(<DecisionSurvey />);
        } else if(currentPath === '/videoCloseForm') {
            setComponentToRender(<VideoCloseForm />);
        } else if(currentPath === '/userDetailsForm') {
            setComponentToRender(<UserDetailsForm />);
        } else if(currentPath === '/contactUploadForm') {
            setComponentToRender(<ContactUploadForm />);
        }  else if(currentPath === '/join') {
            setComponentToRender(<OTPForm />);
        } else  {
            setComponentToRender(<Login />);
        }
    }
  }, [type, name, mobile, whatsapp, language, email, country, state, district, city, pinCode, setUser]);

  return <>{componentToRender}</>;
};

export default RedirectBasedOnQueryParam;
